// extracted by mini-css-extract-plugin
export default {"service_item":"Service_service_item__dS4Jd"};